import { errors } from "com";
import { PROFILES_ENDPOINTS } from "./endpoints";
import type { SaveProfilePayload, UserProfile } from "./types";
import { apiRequestWithData } from "../shared";

const { ValidationError } = errors;

export default async function saveProfile(profile: SaveProfilePayload): Promise<UserProfile> {
  if (!profile || typeof profile !== "object") {
    throw new ValidationError("Profile must be an object");
  }

  return apiRequestWithData<UserProfile>(PROFILES_ENDPOINTS.SAVE, {
    method: "POST",
    body: JSON.stringify(profile),
  });
}
